module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Barbara Paul\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Barbara Paul is the author of numerous short stories and novels in both the detective and science fiction genres. Born in Maysville, Kentucky, she went on to attend Bowling Green State University and the University of Pittsburgh, earning a PhD in theater history and criticism. She has been nominated for the Shamus Award for Best PI Short Story, and two of her novels, "), _c('I', [_vm._v("In-Laws and Outlaws")]), _vm._v(" and "), _c('I', [_vm._v("Kill Fee")]), _vm._v(", have been adapted into television movies. After teaching at the University of Pittsburgh for a number of years, she retired to write full-time. Paul currently resides in Sacramento.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Hk1jcv/tc-custom/9781504032469.jpg?1728387254711",
      "alt": "This image is the cover for the book Chorus of Detectives, The Opera Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Chorus of Detectives, The Opera Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The stars of the Metropolitan Opera search for a crazed killer who plans to bring the company down.")]), _c('br'), _c('br'), _vm._v(" They find the tenor dangling from a water pipe, hanging by his own suspenders. His corpse is still warm. Naturally, the opera’s manager doesn’t stop the production. A dead chorus tenor isn’t enough to close them down, and the show must go on. But there are 139 singers left in the chorus—and someone intends to kill them all."), _c('br'), _c('br'), _vm._v(" Poisoning, strangling, and rigged trapdoors are just a few of the methods at the killer’s disposal. The opera posts guards backstage, but the slayings continue, forcing the Met’s two fading stars, Enrico Caruso and Geraldine Farrar, to band together and save the opera they love so much."), _c('br'), _c('br'), _vm._v(" A Chorus of Detectives is the 3rd book in the Opera Mysteries, but you may enjoy reading the series in any order.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0